module.exports = __webpack_public_path__ + "img/M6_QT_04.2742d8cb.png";